import { useSelector } from "react-redux";
import { ButtonTop } from "./ToTheTopStyle";
import useInstantScroll from "../../../hooks/useInstalntScroll";

const ToTheTop = () => {
  const lang = useSelector(state => state.lang.lang)

  const { jumpToTop } = useInstantScroll();

  return (
    <ButtonTop type="button" onClick={jumpToTop}>
      {lang === "en" ? "To The Top" : "Наверх"}
      
    </ButtonTop>
  );
};

export default ToTheTop;